import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { captureSessionAccess } from './utils/sessionAccess';
import reportWebVitals from './reportWebVitals';

// La clé de lecture d'un lien de session (#k=…) est lue et retirée de
// l'adresse avant tout rendu : aucun composant ne la voit dans l'URL.
if (window.location.pathname.startsWith('/session/')) captureSessionAccess();

if (typeof window !== 'undefined' && /[?&#]debug=(true|1)\b/i.test(window.location.href)) {
  import('eruda').then(({ default: eruda }) => {
    eruda.init();
  }).catch(console.error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
